



















import Vue from "vue";
import {
  EstatisticaLeadService,
  ResultadoCanal,
} from "@/services/estatistica-lead.service";
import { Prop, Watch, Component } from "vue-property-decorator";
import ChartDoughnut from "@/shared/components/chart-doughnut.vue";
import moment from "moment";

const colors: { [key: number]: string } = {
  0: "#D4E157",
  1: "#9CCC65",
  2: "#66BB6A",
  3: "#42A5F5",
  4: "#5C6BC0",
  5: "#EC407A",
  6: "#AB47BC",
  7: "#FFA726",
};

@Component({
  components: {
    ChartDoughnut,
  },
})
export default class GraficoResultadoPorCanal extends Vue {
  loading = false;
  legenda = {
    title: "" as string | number,
    value: "" as string | number,
  };
  dados: ResultadoCanal[] | null = null;
  @Prop({ required: true }) readonly data!: string;

  readonly options: Chart.ChartOptions | Chart.ChartLineOptions = {
    legend: {
      display: false,
    },
  };

  get labels(): string[] {
    return (this.dados && this.dados.map((canal) => canal.nomeCanal)) || [];
  }
  get dataSets(): Chart.ChartDataSets[] {
    return (
      (this.dados && [
        {
          backgroundColor: [
            colors[0],
            colors[1],
            colors[2],
            colors[3],
            colors[4],
            colors[5],
            colors[6],
            colors[7],
          ],
          data: this.dados.map((canal) => canal.quantidade),
        },
      ]) ||
      []
    );
  }

  mounted() {
    this.fetchData();
  }

  @Watch("data")
  async fetchData() {
    this.loading = true;
    try {
      this.dados = await EstatisticaLeadService.listarResultadoCanais(
        moment(`${this.data}-01`).toDate()
      );
    } finally {
      this.loading = false;
    }
  }

  @Watch("dados")
  onValueChange() {
    const dado = this.dados && this.dados[0];
    if (dado) {
      this.legenda.title = dado.nomeCanal;
      this.legenda.value = dado.quantidade;
    }
  }
}
